export default __webpack_public_path__ + "static/media/hms-6.461a0e70.jpg";